import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { showPromotionsDetailModalPage } from 'components/PromotionsDetailModalPage/actions'
import PromoTeaser from './PromoTeaser'
import { googleAnalyticPromotionClicks } from 'actions/googleAnalytic'
import { PROMO_TYPES, REBATE_PROMO, OTHER_PROMO } from './constants'

export default compose(
  connect(null, { showPromotionsDetailModalPage, googleAnalyticPromotionClicks }),
  withHandlers({
    handlePromotionClick: ({
      googleAnalyticPromotionClicks,
      showPromotionsDetailModalPage,
      promotionId,
      disabled,
      item,
      index,
      creative
    }) => () => {
      if (!disabled) {
        showPromotionsDetailModalPage(promotionId)
        googleAnalyticPromotionClicks({ item, index, creative })
      }
    }
  }),
  withProps(
    ({ promotionRebate, promotionType }) => ({
      promotionAsset: PROMO_TYPES[promotionRebate ? REBATE_PROMO : promotionType || OTHER_PROMO]
    })
  )
)(PromoTeaser)

